export type IncidentRule = {
    question: string;
    answer: string;
};
const rules: IncidentRule[] = [
    {
        question: "Respect the privacy of others",
        answer: "Respect the privacy of others. Instigating harassment, revealing someone’s personal or confidential information, is not allowed. Never post or threaten to post intimate or sexually-explicit media of someone without their consent."
    },
    {
        question: "Don’t impersonate of others",
        answer: "Don't impersonate another person, company, or entity.\nMomeento does not allow content that impersonates individuals or entities in a misleading or deceptive manner.\nas well as deep fakes or other manipulated content presented to mislead, or falsely attributed to an individual or entity.."
    },
    {
        question: "Remembers the human",
        answer: "Momeento is a place for sharing real incidents worldwide, community and belonging, not for attacking marginalized or vulnerable groups of people. Everyone has a right to use Momeento free of harassment, bullying, and threats of violence. Users that incite violence or that promote hate based on identity or vulnerability will be banned."
    },
    {
        question: "Help others for real incidents",
        answer: "What incidents are written, will be known to the whole world, and may affect people, groups or regions, so be honest in writing these incidents and accurately"
    },
    {
        question:
            "Do not write incorrect incidents and do not select incorrect location.",
        answer: "To create more confidence in the content of the incidents, and because millions of users see it and react with it, which is reflected in the integrity and credibility of using momeento.\nMomeento confirms compliance with the instructions."
    },
    {
        question: "Don’t break Momeento (a lot of us really like here}",
        answer: "Don't break momeento or do anything that interferes with normal use of the application. Do not interrupt the serving of momeento, introduce malicious code onto momeento, make it difficult for anyone else to use momeento due to your actions, block sponsored headlines, create programs that violate any of our other API rules, or assist anyone in misusing momeetn to in any way."
    },
    {
        question:
            "Keep it legal, and avoid posting illegal content or soliciting or facilitating illegal or prohibited transactions.",
        answer: "Content is prohibited if it uses momeento to solicit or facilitate any transaction or gift involving certain goods and services. You may not use momeento to solicit or facilitate any transaction or gift involving certain goods and services, including:\n- Firearms, ammunition, explosives, legally controlled firearms parts or accessories\n- Paid services involving physical sexual contact\n Stolen goods\n- Personal information\n- Falsified official documents or currency\n- Fraudulent services"
    },
    {
        question: "Never post or threaten to post intimate or locations",
        answer: "Never post or threaten to post intimate incidents, families incidents or locations. don't breach others privacy."
    },
    {
        question:
            "It is forbidden to report fake and unreal incidents, and the users bears all responsibility.",
        answer: "The policy of the application must be respected and not to post unreal incidents or to breach the privacy of others by publishing photos or videos without their consent. Not to use momeento for political or social purposes or to spread intimidation among people."
    }
];

export default rules;
